






















import { Vue, Component } from 'vue-property-decorator';
import { vxm } from '@/store.vuex';
declare var window: any;

@Component
export default class OnBoarding extends Vue {
  get isEssiumIntegrationPage() {
    return (
      vxm.users.isLoggedIn && vxm.configs.subSectionEnabledInHomePage(
      'ONBOARDING',
      'ENABLE_ESSIUM_INTEGRATION',
    ) &&
      this.$route.path === '/onboarding'
    );
  }

  beforeMount() {
    vxm.utility.setSpinnerStatus(true);
  }

  essiumLoaded() {
    setTimeout(() => {
      vxm.utility.setSpinnerStatus(false);
    }, 1000);
  }
}
